module.exports = __webpack_public_path__ + "img/new_logo_pic.d83f7fb6.png";